
import React from 'react';
import AddRuleItem from './AddRuleItem';

class RuleSendAfter extends React.Component {
    constructor(props) {
        super(props);

        
        this.defaultState = this.defaultState.bind(this);
        this.showSelector = this.showSelector.bind(this);
        this.swapEdit = this.swapEdit.bind(this);
        this.defaultState(props);
        this.displayValue = this.displayValue.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.saveCustom = this.saveCustom.bind(this);
        this.available = {
            '0' : 'a couple of seconds',
            '1' : '1 hour',
            '2' : '2 hours',
            '3' : '3 hours',
            '4' : '4 hours',
            '5' : '5 hours',
            '6' : '6 hours',
            '7' : '7 hours',
            '8' : '8 hours',
            '9' : '9 hours',
            '10' : '10 hours',
            '11' : '11 hours',
            '12' : '12 hours',
            '13' : '13 hours',
            '14' : '14 hours',
            '15' : '15 hours',
            '16' : '16 hours',
            '17' : '17 hours',
            '18' : '18 hours',
            '19' : '19 hours',
            '20' : '20 hours',
            '21' : '21 hours',
            '22' : '22 hours',
            '23' : '23 hours',
            '24' : '1 day',
            '36' : '1 1/2 days',
            '48' : '2 days', 
            '72' : '3 days',
            '96' : '4 days',
            '120' : '5 days',
            '144' : '6 days',
            '168' : '1 week',
            '336' : '2 weeks',
            '504' : '3 weeks',
            '730' : '1 month',
            '1460' : '2 months',
            '2190' : '3 months',
            '2920' : '4 months',
            '3650' : '5 months',
            '4380' : '6 months',
            '5110' : '7 months',
            '5840' : '8 months',
            '6570' : '9 months',
            '7300' : '10 months',
            '8030' : '11 months',
            '8760' : '12 months',
        };
        
    }

    swapEdit(e) {
        this.setState({'isEditing':!this.state.isEditing});
    }

    defaultState(props) {
        this.state = {
            'isEditing':false,
            'isCustom':false,
            'custom':'',
        };
    }

    displayValue(value) {
        value = parseInt(value);

        if(this.available[value]) {
            return this.available[value];
        }

        return Math.round(parseInt(value)/24)+' days';
    }

    componentWillMount() {
        if(this.props.onlyDescription) {
            return;
        }
        if(this.props.rule.value == '') {
            this.props.setGlobalTypeState('rules',this.props.rule.id,{'value':4});
        }
    }

    handleOnChange(i) {
        this.swapEdit();
        this.props.setGlobalTypeState('rules',this.props.rule.id,{'value':i});
    }

    saveCustom(e) {
        e.stopPropagation();
        this.props.setGlobalTypeState('rules',this.props.rule.id,{'value':parseInt(this.state.custom)*24});
        this.setState({'isCustom':false,'custom':'',isEditing:false});
    }

    showSelector() {

        if(!this.state.isEditing) {
            return <span onClick={(e) => {e.stopPropagation();this.swapEdit(e);} } className="selected-rule">{this.displayValue(this.props.rule.value)}</span>;
        }

        if(this.state.isCustom) {
            return (
                <div className="dropdown open">
                    <button type="button" className="btn btn-dark dropdown-toggle btn-sm" aria-expanded="true" data-toggle="dropdown">
                        {this.state.custom == false ? 'Click here to add days':this.displayValue(parseInt(this.state.custom)*24)}
                        <span className="caret"></span>
                    </button>

                    <div className="dropdown-menu">
                        <div className="mega-content">
                                <div className="col-sm-12">
                                    <div className="input-group">
                                        <input className="form-control" type="text" value={this.state.custom} onChange={(e) => {this.setState({'custom':e.target.value})}} placeholder="Enter number of days" />
                                        <span className="input-group-addon">days</span>
                                    </div>
                                </div>

                                <div className="col-sm-12 m-t-5 m-b-10">
                                    <div className="col-sm-6 p-0 ">
                                        <button className="btn btn-danger btn-block" onClick={() => {this.setState({'isCustom':false,'custom':''})}}>Don't use custom</button>
                                    </div>
                                    <div className="col-sm-6 p-0 ">
                                       <button className="btn btn-dark btn-block" onClick={this.saveCustom}>Save</button>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="dropdown open">
                <button type="button" className="btn btn-dark dropdown-toggle btn-sm" aria-expanded="true" data-toggle="dropdown">
                    {this.displayValue(this.props.rule.value)}
                    <span className="caret"></span>
                </button>
                <div className="dropdown-menu">
                    <div className="dropdown-submenu">
                        <a href="javascript:void(0)" className="dropdown-item" role="button" tabIndex="-1">Hours</a>
                        <div className="dropdown-menu" role="menu">
                            {
                                Object.keys(this.available).map((i) => {
                                    if(i < 24) {
                                        return <a key={i} onClick={(e) => {e.stopPropagation(); this.handleOnChange(i)}} className="dropdown-item" href="javascript:void(0)" role="menuitem" tabIndex="-1">{this.available[i]}</a>
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div className="dropdown-submenu">
                        <a href="javascript:void(0)" className="dropdown-item" role="button" tabIndex="-1">Days</a>
                        <div className="dropdown-menu" role="menu">
                            {
                                Object.keys(this.available).map((i) => {
                                    if(i >= 24 && i <= 144) {
                                        return <a key={i} onClick={(e) => {e.stopPropagation(); this.handleOnChange(i)}} className="dropdown-item" href="javascript:void(0)" role="menuitem" tabIndex="-1">{this.available[i]}</a>
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div className="dropdown-submenu">
                        <a href="javascript:void(0)" className="dropdown-item" role="button" tabIndex="-1">Weeks</a>
                        <div className="dropdown-menu" role="menu">
                            {
                                Object.keys(this.available).map((i) => {
                                    if(i >= 146 && i <= 504) {
                                        return <a key={i} onClick={(e) => {e.stopPropagation(); this.handleOnChange(i)}} className="dropdown-item" href="javascript:void(0)" role="menuitem" tabIndex="-1">{this.available[i]}</a>
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div className="dropdown-submenu">
                        <a href="javascript:void(0)" className="dropdown-item" role="button" tabIndex="-1">Months</a>
                        <div className="dropdown-menu" role="menu">
                            {
                                Object.keys(this.available).map((i) => {
                                    if(i > 504) {
                                        return <a key={i} onClick={(e) => {e.stopPropagation(); this.handleOnChange(i)}} className="dropdown-item" href="javascript:void(0)" role="menuitem" tabIndex="-1">{this.available[i]}</a>
                                    }
                                })
                            }
                        </div>
                    </div>
                    <a href="javascript:void(0)" className="dropdown-item" role="button" onClick={() => {this.setState({'isCustom':true,'custom':''}); }} tabIndex="-1">Custom</a>
                </div>
            </div>
        );




    }

    render() {
        if(this.props.onlyDescription) {
            return <AddRuleItem select={this.props.addRule} value="0" operator=">=" action="When" ruleKey={this.props.ruleKey} title="Display limit" description="Define how many times this popup should be shown to the same customer" />
        }
        return (
                <div className="list-group-item blue-grey-500">
                    <i className="icon wb-arrow-right" aria-hidden="true"></i>
                    Send after {this.showSelector()}
                </div>
        );
    }

  
}

export default RuleSendAfter;




// WEBPACK FOOTER //
// ./components/builder/RuleSendAfter.js